<template>
  <div id="calendar-tab1" class="calendar-tab-pc">
    <calendar-header :nameCodapp="labels[nowLang].nameCodapp" :linkToRedirect="linkToRedirect" :tooltip="header_tooltip" />
    <div class="body-pc">
      <template v-for="value in filterCalendarTab({ tab: 'tab1', calendarTabRows: calendarTab1.rows })">
        <filter-date :showTabDate="showTabDate"/>
        <div class="panel-body add-border">
          <div class="clearfix">
            <div class="head-tab-left font-bold  head-font" v-bind:class="color[value.staappr]">
              <i class="font-padding fa" v-bind:class="icon[value.staappr]"></i>{{ value.status }}</div>
            <div class="head-tab-right">   {{ setDateRangeOutput(dateRange(value.dtestrt, value.dteend)) }} <br>
              <span class="color-green color-skin"><i class="fa fa-clock-o font-padding"></i>{{ timeRange(value.timstrt, value.timend) }}</span>
            </div>
          </div>
          <calendar-detail :description="labels[nowLang].type" :descDetail="value.descType"/>
          <calendar-detail :description="labels[nowLang].description" :descDetail="value.descDetail"/>
          <calendar-detail :description="labels[nowLang].remark" :descDetail="value.remark" v-if="value.staappr == 'N'"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import calendarHeader from 'components/calendar/calendar_header'
import filterDate from 'components/calendar/filter_date'
import calendarDetail from 'components/calendar/calendar_detail'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'calendar-tab1',
  props: [ 'calendarTab1', 'filterCalendarTab', 'nowLang' ],
  data () {
    return {
      linkToRedirect: 'hres62e',
      header_tooltip: 'Link to Leave page',
      labels: {
        en: {
          nameCodapp: 'Leave',
          type: 'Type',
          description: 'Detail',
          remark: 'Remark'
        },
        th: {
          nameCodapp: 'วันลาหยุดงาน',
          type: 'ประเภท',
          description: 'รายละเอียด',
          remark: 'หมายเหตุ'
        }
      },
      color: {
        'P': 'color-black',
        'Y': 'color-lime',
        'N': 'color-red',
        'A': 'color-yellow',
        'C': 'color-gray'
      },
      icon: {
        'P': 'fa-square-o',
        'Y': 'fa-check-square-o',
        'N': 'fa-window-close-o',
        'A': 'fa-external-link',
        'C': 'fa-minus-square-o'
      }
    }
  },
  methods: {
    setDateRangeOutput (date) {
      return assetsUtils.getDateRangeOutput(date)
    },
    timeFormat (time) {
      let timeReplaced = time.replace(':', '')
      return timeReplaced.substr(0, 2) + ':' + timeReplaced.substr(2, 2)
    },
    timeRange (timstrt, timeend) {
      if (timstrt !== '' || timeend !== '') {
        return this.timeFormat(timstrt) + ' - ' + this.timeFormat(timeend)
      }
      return ''
    },
    dateRange (dtestrt, dteend) {
      if (dtestrt !== '' || dteend !== '') {
        return dtestrt + ' - ' + dteend
      }
      return ''
    }
  },
  components: {
    calendarHeader,
    filterDate,
    calendarDetail
  }
}
</script>

<style>
  .box-tab1{
    border-bottom: 1px solid #e8e8e8;
  }
  .add-border{
    border-bottom: 1px solid #e8e8e8;
  }
</style>


// WEBPACK FOOTER //
// calendar_tab1.vue?2468a588